module.exports = __webpack_public_path__ + "static/img/code-o.befbab4d.png";